<template>
  <div
    v-if="visible"
    class="mb-4 rounded-lg bg-red-700 text-white p-3 shadow"
  >
    <div class="flex items-start">
      <div class="flex-1 pr-2">
        <div class="text-base font-semibold leading-5">Install the EBM app</div>
        <div class="mt-1 text-sm text-red-100 leading-5">
          Add it to your home screen and open it like an app.
        </div>
      </div>
      <button
        type="button"
        class="ml-1 -mt-1 p-1 text-red-100 hover:text-white focus:outline-none"
        aria-label="Dismiss install banner"
        @click="onDismiss"
      >
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <button
      type="button"
      class="mt-3 w-full rounded-md bg-white text-red-700 text-sm font-semibold py-2 px-3 hover:bg-red-50 focus:outline-none"
      @click="onInstall"
    >
      Install app
    </button>
  </div>
</template>

<script>
import eventBus from "../utils/eventBus";
import {
  isPwaBannerDismissed,
  dismissPwaBanner,
  requestPwaInstall,
  pwaUiState,
} from "../utils/pwaInstall";

export default {
  name: "PwaInstallBanner",
  data() {
    return {
      bannerDismissed: isPwaBannerDismissed(),
      pwaUiState,
    };
  },
  computed: {
    visible() {
      return this.pwaUiState.offered && !this.bannerDismissed;
    },
  },
  created() {
    eventBus.$on("pwa-banner-dismissed", this.markDismissed);
    eventBus.$on("pwa-app-installed", this.markDismissed);
  },
  beforeDestroy() {
    eventBus.$off("pwa-banner-dismissed", this.markDismissed);
    eventBus.$off("pwa-app-installed", this.markDismissed);
  },
  methods: {
    markDismissed() {
      this.bannerDismissed = true;
    },
    onDismiss() {
      dismissPwaBanner();
    },
    onInstall() {
      requestPwaInstall();
    },
  },
};
</script>
